// Generated from /Users/j.alley/Downloads/products_export_1.csv on 2026-05-26.
window.CAPITAL_DRINKS_PRODUCTS = [
  {
    "title": "*12 PACK* Coke 12x500MI",
    "sku": "209",
    "cost": 5.5,
    "handle": "coke-500mi-x12",
    "category": "Home & Garden > Kitchen & Dining > Kitchen Appliance Accessories > Soda Maker Accessories > Bottles",
    "status": "draft"
  },
  {
    "title": "12x330ml San Pellegrino Slim Can Pompelmo (Grapefruit)",
    "sku": "184",
    "cost": 10.79,
    "handle": "12x330ml-san-pellegrino-slim-can-pompelmo-grapefruit",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "active"
  },
  {
    "title": "24x330ml San Pellegrino Slim Can Mel E Aran (Pom & Ora)",
    "sku": "183",
    "cost": 10.79,
    "handle": "12x330ml-san-pellegrino-slim-can-mel-e-aran-pom-ora",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "active"
  },
  {
    "title": "7Up 500Ml X24",
    "sku": "259",
    "cost": 15.99,
    "handle": "7up-500ml-x24",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "active"
  },
  {
    "title": "7Up Cans 330Ml X24",
    "sku": "136",
    "cost": 6.99,
    "handle": "7up-cans-330ml-x24",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "active"
  },
  {
    "title": "Avant Still Water 24 x 500ml",
    "sku": "237",
    "cost": 3.29,
    "handle": "avant-still-water-12-x-200ml",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Boost Bar Std X48",
    "sku": "337",
    "cost": 18.99,
    "handle": "boost-bar-std-x48",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "draft"
  },
  {
    "title": "Boost Energy Drink Cans 250MI X24",
    "sku": "103",
    "cost": 7.49,
    "handle": "boost-energy-drinks-250mi-x24",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Bottlegreen 275MI x12",
    "sku": "207",
    "cost": 9.99,
    "handle": "bottle-green-275mi",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Bottlegreen Elderflower Cordial 6x500ml",
    "sku": "264",
    "cost": 13.49,
    "handle": "bottlegreen-elderflower-cordial-6x500ml",
    "category": "Food, Beverages & Tobacco > Beverages > Cordials, Syrups & Squash",
    "status": "active"
  },
  {
    "title": "Bottlegreen Pomegranate Elderflower 6x500ML",
    "sku": "208",
    "cost": 12.99,
    "handle": "bottlegreen-pomegranate-eld-6x500ml",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Bounty Blue X24",
    "sku": "336",
    "cost": 10.0,
    "handle": "bounty-blue-57g-x24",
    "category": "Food, Beverages & Tobacco > Food Items > Candy & Chocolate > Chocolate",
    "status": "active"
  },
  {
    "title": "Carabao Energy Drinks 330MI X12",
    "sku": "105",
    "cost": 0.0,
    "handle": "carabao-energy-drinks-330mi-x12",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Cawston Press Cranberry Juice 6 X 1L",
    "sku": "233",
    "cost": 18.99,
    "handle": "cranberry-juice-1-ltr-x6",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Cawston Press Squeezed Orange Juice 6x1L",
    "sku": "263",
    "cost": 15.49,
    "handle": "cawston-press-squeezed-orange-juice-6x1l",
    "category": "Food, Beverages & Tobacco > Beverages > Juices, Milkshakes & Smoothies",
    "status": "active"
  },
  {
    "title": "Cawston Press Tomato Juice 6x1L",
    "sku": "265",
    "cost": 10.99,
    "handle": "tomato-juice-1l-x12",
    "category": "Food, Beverages & Tobacco > Beverages > Juices, Milkshakes & Smoothies",
    "status": "active"
  },
  {
    "title": "Coke 24x500ml",
    "sku": "258",
    "cost": 15.59,
    "handle": "coke-500ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Coke 500MI X18",
    "sku": "205",
    "cost": 0.0,
    "handle": "coke-500mi-x18",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Coke Cans 24 X 330Ml",
    "sku": "135",
    "cost": 9.39,
    "handle": "coke-cans-24x330ml",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "active"
  },
  {
    "title": "Coke Icon Glass 24 X 330MI Nrb",
    "sku": "213",
    "cost": 0.0,
    "handle": "coke-icon-glass-24-x-330mi-nrb",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Coke Mini Cans 24 x 150ml",
    "sku": "114",
    "cost": 11.99,
    "handle": "coca-cola-mini-can-24-x-150ml",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Coke Zero 500Ml X24",
    "sku": "257",
    "cost": 12.49,
    "handle": "coke-zero-500ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Coke Zero Bottles 12x500ml",
    "sku": "201",
    "cost": 7.99,
    "handle": "coke-zero-bottles-12x500ml",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "draft"
  },
  {
    "title": "Coke Zero Cans 330Ml X24",
    "sku": "134",
    "cost": 8.79,
    "handle": "coke-zero-can-330ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Coke Zero Mini Cans 24x150ml",
    "sku": "137",
    "cost": 10.99,
    "handle": "coke-zero-mini-cans-24-x-150ml",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "active"
  },
  {
    "title": "Crunchie Bar Std X48- Offer",
    "sku": "335",
    "cost": 16.0,
    "handle": "crunchie-bar-std-x48",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Dg Ginger Cans 330MI X24",
    "sku": "104",
    "cost": 7.99,
    "handle": "dg-ginger-cans-330mi-x24",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Diet Coke 500Ml X24",
    "sku": "256",
    "cost": 12.49,
    "handle": "diet-coke-500ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Diet Coke Cans 330Ml X24",
    "sku": "133",
    "cost": 7.69,
    "handle": "diet-coke-can-330ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Diet Coke Icon Glass 24 X 330MI Nrb",
    "sku": "212",
    "cost": 0.0,
    "handle": "diet-coke-icon-glass-24-x-330mi-nrb",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Diet Coke Mini Cans 24 x 150ml",
    "sku": "115",
    "cost": 10.99,
    "handle": "cola-diet-coke-24-x-150ml",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Double Decker Std X48",
    "sku": "334",
    "cost": 20.99,
    "handle": "double-decker-std-x48",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Dr Pepper 12x500ml",
    "sku": "297",
    "cost": 7.99,
    "handle": "dr-pepper-12x500ml",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "draft"
  },
  {
    "title": "Dr Pepper 500Ml X24",
    "sku": "255",
    "cost": 12.49,
    "handle": "dr-pepper-500ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Dr Pepper Cans 330Ml X24",
    "sku": "132",
    "cost": 7.99,
    "handle": "dr-pepper-can-330ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "EAGER Juice - Cloudy - 8X1L",
    "sku": "299",
    "cost": 0.0,
    "handle": "eager-juice-cloudy-8x1l",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Eat Natural Almond Apricot & Yoghurt 12 X 50G",
    "sku": "312",
    "cost": 0.0,
    "handle": "eat-natural-almond-apricot-yoghurt-12-x-50g",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Eat Natural Bar Peanut Almond 12 X 45g",
    "sku": "311",
    "cost": 0.0,
    "handle": "eat-natural-bar-peanut-almond-12-x-45g",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Eat Natural Brazils Sultanas Almonds & Hazelnuts X12 50G",
    "sku": "306",
    "cost": 0.0,
    "handle": "eat-natural-brazils-sultanas-almonds-hazelnuts-x12-50g",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Eat Natural Cashews Blueberries & Yoghurt X12 45G",
    "sku": "305",
    "cost": 0.0,
    "handle": "eat-natural-cashews-blueberries-yoghurt-x12-45g",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Evian 1.5L X8",
    "sku": "227",
    "cost": 5.27,
    "handle": "evian-1-5ltr-x8",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Evian 330MI X24",
    "sku": "220",
    "cost": 7.59,
    "handle": "evian-330mi-x24",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Evian 500MI X24",
    "sku": "221",
    "cost": 5.83,
    "handle": "evian-500mi-x24",
    "category": "",
    "status": "active"
  },
  {
    "title": "Evian Sparkling Water 24x 330ml Cans",
    "sku": "118",
    "cost": 0.0,
    "handle": "evian-sparkling-natural-mineral-water-24x-330ml-cans",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Fairfields Farm Cheese & Onion 36x40g",
    "sku": "413",
    "cost": 12.6,
    "handle": "fairfields-farm-cheese-onion-36x40g",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Fairfields Farm Lightly Salted 36x40g",
    "sku": "412",
    "cost": 12.6,
    "handle": "fairfields-farm-lightly-salted-36x40g",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Fairfields Farm Roast Rib of Beef 36x40g",
    "sku": "411",
    "cost": 12.6,
    "handle": "fairfields-farm-roast-rib-of-beef-36x40g",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Fairfields Farm Sea Salt & Aspall Cyder Vinegar 36x40g",
    "sku": "410",
    "cost": 12.6,
    "handle": "fairfields-farm-sea-salt-aspall-cyder-vinegar-36x40g",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Fairfields Farm Sweet Chilli 36x40g",
    "sku": "409",
    "cost": 12.6,
    "handle": "fairfields-farm-sweet-chilli-36x40g",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Fanta Elderflower & Lemon 330MI X24",
    "sku": "106",
    "cost": 0.0,
    "handle": "fanta-elderflower-lemon-330mi-x24",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Fanta Exotic Cans 24 X 330Ml",
    "sku": "131",
    "cost": 8.99,
    "handle": "fanta-exotic-cans-24x330ml",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Fanta Fruit Twist 500Ml X12",
    "sku": "251",
    "cost": 7.99,
    "handle": "fanta-twist-500ml-x12",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "active"
  },
  {
    "title": "Fanta Lemon 500Ml X24",
    "sku": "254",
    "cost": 12.59,
    "handle": "fanta-lemon-500ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Fanta Lemon Cans 330Ml X24",
    "sku": "130",
    "cost": 7.99,
    "handle": "fanta-lemon-can-330ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Fanta Orange 500Ml X24",
    "sku": "253",
    "cost": 12.59,
    "handle": "fanta-orange-500ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Fanta Orange Bottles 12x500ml",
    "sku": "203",
    "cost": 7.99,
    "handle": "fanta-orange-bottles-12x500ml",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "draft"
  },
  {
    "title": "Fanta Orange Cans 24 X 330Ml",
    "sku": "129",
    "cost": 7.99,
    "handle": "fanta-orange-cans-24x330ml",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Fanta Pineapple & Grapefruit 24 x 330ml",
    "sku": "116",
    "cost": 0.0,
    "handle": "fanta-pineapple-grapefruit-24-x-330ml",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Fanta Red Grape 12x 500ML",
    "sku": "234",
    "cost": 7.49,
    "handle": "fanta-red-grape-zero-500ml-x12",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Fanta Shokata 500Ml X12",
    "sku": "252",
    "cost": 7.75,
    "handle": "fanta-shokata-500ml-x12",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Fanta Strawberry Kiwi Cans 24x330ml",
    "sku": "117",
    "cost": 0.0,
    "handle": "fanta-strawberry-kiwi-cans-24x330ml-offer",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Fanta Tropical Exotic 12x500ml",
    "sku": "204",
    "cost": 7.75,
    "handle": "fanta-tropical-12x500ml",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Fanta Twist Cans 330Ml X24",
    "sku": "128",
    "cost": 7.99,
    "handle": "fanta-twist-can-330ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "FLAPJACKS 120G IND 30 Cherry & Almond",
    "sku": "333",
    "cost": 11.0,
    "handle": "flapjacks-120g-ind-30-cherry-almond",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "FLAPJACKS 120G IND 30 Choc Chip",
    "sku": "332",
    "cost": 10.8,
    "handle": "flapjacks-120g-ind-30-choc-chip",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "FLAPJACKS 120G IND 30 Yoghurt",
    "sku": "331",
    "cost": 10.8,
    "handle": "flapjacks-120g-ind-30-yoghurt",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Highland Sparkling 1.5Ltr X12",
    "sku": "226",
    "cost": 0.0,
    "handle": "highland-sparkling-1-5ltr-x12",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Highland Spring Still Water 1.5Ltr X12",
    "sku": "225",
    "cost": 0.0,
    "handle": "highland-spring-still-water-1-5ltr-x12",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Hildon Still Mineral Water 24x 330ml",
    "sku": "271",
    "cost": 8.99,
    "handle": "hildon-still-mineral-water-24x-330ml",
    "category": "Food, Beverages & Tobacco > Beverages > Water > Carbonated Water",
    "status": "active"
  },
  {
    "title": "Huel Chocolate Drink 8 x 500ml",
    "sku": "273",
    "cost": 15.5,
    "handle": "huel-chocolate-drink-8-x-500ml",
    "category": "Food, Beverages & Tobacco > Beverages > Powdered Beverage Mixes",
    "status": "draft"
  },
  {
    "title": "Huel Drink Vanilla 8 x 500ml",
    "sku": "245",
    "cost": 15.5,
    "handle": "huel-drink-vanilla-8-x-500ml",
    "category": "Food, Beverages & Tobacco > Beverages > Powdered Beverage Mixes",
    "status": "draft"
  },
  {
    "title": "Hula Hoops BBQ Beef - 32x34g",
    "sku": "402",
    "cost": 0.0,
    "handle": "hula-hoops-bbq-beef-32x34g",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Hula Hoops Ready Salted - Pack Size 32x34g",
    "sku": "401",
    "cost": 0.0,
    "handle": "hula-hoops-ready-salted-pack-size-32x34g",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Irn Bru Cans 24 X 330MI",
    "sku": "113",
    "cost": 0.0,
    "handle": "irn-bru-cans-24-x-330mi",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Juice Burst Apple Juice 12X500ml",
    "sku": "239",
    "cost": 7.49,
    "handle": "sunmagic-apple-12x500ml",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Juice Burst Orange Juice 12X500ml",
    "sku": "277",
    "cost": 9.59,
    "handle": "juice-burst-orange-juice-12x500ml",
    "category": "Food, Beverages & Tobacco > Beverages > Juices, Milkshakes & Smoothies",
    "status": "active"
  },
  {
    "title": "Just Juice Apple 12 X 1L",
    "sku": "231",
    "cost": 13.99,
    "handle": "apple-juice-1-ltr-x12",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Kettle Crisps Lightly Salted 54x40g",
    "sku": "433",
    "cost": 16.99,
    "handle": "kettle-crisps-lightly-salted-54x40g",
    "category": "Food, Beverages & Tobacco > Food Items > Snack Foods",
    "status": "draft"
  },
  {
    "title": "Kettle Crisps Mature Cheddar & Red Onion 54x40g",
    "sku": "431",
    "cost": 16.99,
    "handle": "kettle-crisps-mature-cheddar-and-red-onion-54x40g",
    "category": "Food, Beverages & Tobacco > Food Items > Snack Foods",
    "status": "draft"
  },
  {
    "title": "Kettle Crisps Sea Salt & Balsamic Vinegar 54x40g",
    "sku": "430",
    "cost": 16.99,
    "handle": "kettle-crisps-sea-salt-and-balsamic-vinegar-of-modena-54x40g",
    "category": "Food, Beverages & Tobacco > Food Items > Snack Foods",
    "status": "draft"
  },
  {
    "title": "Kettle Crisps Sweet Chilli & Sour Cream 54x40g",
    "sku": "432",
    "cost": 16.99,
    "handle": "kettle-crisps-sweet-chilli-and-sour-cream-54x40g",
    "category": "Food, Beverages & Tobacco > Food Items > Snack Foods",
    "status": "draft"
  },
  {
    "title": "Kinder Bueno White 43G X30",
    "sku": "330",
    "cost": 12.5,
    "handle": "kinder-bueno-white-43g-x30",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Kinder Bueno X30",
    "sku": "329",
    "cost": 12.5,
    "handle": "kinder-bueno-x30",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Kit Kat 4 Finger 24x47g",
    "sku": "328",
    "cost": 10.0,
    "handle": "kit-kat-4-finger-47g-x24",
    "category": "Food, Beverages & Tobacco > Food Items > Candy & Chocolate > Chocolate",
    "status": "active"
  },
  {
    "title": "Kit Kat 4 Finger White 24x41.5g",
    "sku": "351",
    "cost": 10.0,
    "handle": "kit-kat-4-finger-white-24x41-5g",
    "category": "Food, Beverages & Tobacco > Food Items > Candy & Chocolate > Chocolate",
    "status": "active"
  },
  {
    "title": "Kit Kat Chunky 24x40g",
    "sku": "302",
    "cost": 10.0,
    "handle": "kit-kat-chunky-40g-x36",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Kit Kat Chunky Peanut Butter 24x40g",
    "sku": "352",
    "cost": 9.6,
    "handle": "kit-kat-chunky-peanut-butter-24x40g",
    "category": "Food, Beverages & Tobacco > Food Items > Candy & Chocolate > Chocolate",
    "status": "active"
  },
  {
    "title": "Kit Kat Chunky White 24x40g",
    "sku": "349",
    "cost": 10.0,
    "handle": "kitkat-chunky-white-chocolate-bar-24x40g",
    "category": "Food, Beverages & Tobacco > Food Items > Candy & Chocolate > Chocolate",
    "status": "active"
  },
  {
    "title": "Kit Kat Hazelnut 24x41.5g",
    "sku": "341",
    "cost": 9.5,
    "handle": "kit-kat-hazelnut-24x41-5g",
    "category": "Food, Beverages & Tobacco > Food Items > Candy & Chocolate > Chocolate",
    "status": "draft"
  },
  {
    "title": "Lichefield Apple Juice 8x250ml",
    "sku": "356",
    "cost": 6.0,
    "handle": "lichefield-apple-juice-8x250ml",
    "category": "Food, Beverages & Tobacco > Beverages > Juices, Milkshakes & Smoothies",
    "status": "active"
  },
  {
    "title": "Lion - Chocolate Bar White - 24 Bars",
    "sku": "309",
    "cost": 0.0,
    "handle": "lion-chocolate-bar-white-24-bars",
    "category": "",
    "status": "active"
  },
  {
    "title": "Lion Bar Chocolate Standard 40x42G",
    "sku": "301",
    "cost": 14.0,
    "handle": "lion-bar-dark-std-50g-x40",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "LION CHOCOLATE 40G X40",
    "sku": "327",
    "cost": 12.99,
    "handle": "lion-chocolate-40x40g",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Lion Chocolate Black and White 40 X 42g",
    "sku": "375",
    "cost": 14.0,
    "handle": "lion-black-and-white-40-x-42g",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Lion Peanut Std 40X42G",
    "sku": "326",
    "cost": 14.0,
    "handle": "lion-peanut-std-50g-x40",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Lion White Std Bar 40G X40",
    "sku": "325",
    "cost": 14.0,
    "handle": "lion-white-std-bar-40g-x40",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Lipton Ice Tea Lemon 500Ml X24",
    "sku": "250",
    "cost": 11.99,
    "handle": "lipton-ice-tea-lemon-500ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Lipton Peach 500Ml X24",
    "sku": "249",
    "cost": 11.99,
    "handle": "lipton-peach-500ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Liptons Ice Tea Mango Pet 12 X 500MI",
    "sku": "216",
    "cost": 7.99,
    "handle": "liptons-ice-tea-mango-pet-12-x-500mi",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Liptons Ice Tea Raspberry Pet 12 X 500Ml",
    "sku": "248",
    "cost": 5.99,
    "handle": "lipton-ice-tea-raspberry-500ml-x12",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Lucozade Orange 500Ml X24",
    "sku": "247",
    "cost": 17.69,
    "handle": "lucozade-energy-orange-500ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Lucozade Orange Cans 24x330ml",
    "sku": "127",
    "cost": 7.59,
    "handle": "lucozade-orange-energy-24x330ml",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Lucozade Original 24X 500Ml",
    "sku": "246",
    "cost": 17.79,
    "handle": "lucozade-original-energy-500ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Lucozade Original Cans 24x330ml",
    "sku": "126",
    "cost": 7.49,
    "handle": "lucozade-original-energy-24x330ml",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "draft"
  },
  {
    "title": "Lucozade Sport Orange 12x500ML",
    "sku": "217",
    "cost": 0.0,
    "handle": "lucozade-sport-orange-12x500ml",
    "category": "",
    "status": "draft"
  },
  {
    "title": "MA BAKER Chocolate Smoothie Bar Choc Chip 20x100g",
    "sku": "308",
    "cost": 0.0,
    "handle": "ma-baker-chocolate-smoothie-bar-choc-chip-20x100g",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Mars Bar Std 51G X40",
    "sku": "324",
    "cost": 14.5,
    "handle": "mars-bar-std-51g-x40",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "McCoy's Ridge Cut Crisps - Cheese & Onion 45g x 26",
    "sku": "403",
    "cost": 0.0,
    "handle": "mccoys-ridge-cut-crisps-cheese-onion-45g-x-26",
    "category": "",
    "status": "draft"
  },
  {
    "title": "McCoys Std 32G X30",
    "sku": "400",
    "cost": 0.0,
    "handle": "mccoys-std-32g-x30",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Mentos Fruit 40X37.5g",
    "sku": "371",
    "cost": 12.0,
    "handle": "mentos-fruit-40x37-5-gm",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Mentos Fruit Sweets 40x38g",
    "sku": "313",
    "cost": 12.0,
    "handle": "mentos-fruit-sweets-40x38g",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Mentos Mint 40X37.5g",
    "sku": "374",
    "cost": 12.0,
    "handle": "mentos-mint-40x37-5-gm",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Mentos Mint Sweets 40x38g",
    "sku": "314",
    "cost": 12.0,
    "handle": "mentos-mint-sweets-40x38g",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Mentos Rainbow 40X37.5g",
    "sku": "372",
    "cost": 12.0,
    "handle": "mentos-rainbow-40x37-5-gm",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Mentos Spearmint Sweets 40x38g",
    "sku": "315",
    "cost": 12.99,
    "handle": "mentos-spearmint-sweets-40x38g",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Mentos Strawberry 40X37.5g",
    "sku": "373",
    "cost": 12.0,
    "handle": "mentos-strawberry-40x37-5-gm",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Milky Way Twin 28 x 43g",
    "sku": "323",
    "cost": 13.0,
    "handle": "milky-way-twin-28-x-43g",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Mini Ginger Ale Cans 24x150ml",
    "sku": "272",
    "cost": 0.0,
    "handle": "mini-ginger-ale-cans-24x150ml",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "active"
  },
  {
    "title": "Monster Energy Original Cans 24x500ml",
    "sku": "101",
    "cost": 15.99,
    "handle": "monster-energy-original-12x500ml",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Monster Mango Loco Cans 24x500ml",
    "sku": "149",
    "cost": 20.99,
    "handle": "monster-mango-loco-cans-12x500ml",
    "category": "Food, Beverages & Tobacco > Beverages > Sports & Energy Drinks > Energy Drinks",
    "status": "active"
  },
  {
    "title": "Monster Ultra White Cans 12x500ml",
    "sku": "100",
    "cost": 9.99,
    "handle": "monster-ultra-white-12x500ml",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Oasis Citrus 500MI X12",
    "sku": "235",
    "cost": 8.79,
    "handle": "oasis-citrus-500mi-x12",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Oasis Summer Fruits 500Ml X12",
    "sku": "244",
    "cost": 8.79,
    "handle": "oasis-summer-fruits-500ml-x12",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Ocean Spray Cranberry Classic 12 X 1L",
    "sku": "222",
    "cost": 8.49,
    "handle": "ocean-spray-cranberry-classic-12-x-1lt-cartons",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Pepsi 24x500m",
    "sku": "200",
    "cost": 14.99,
    "handle": "pepsi-24x500ml",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "active"
  },
  {
    "title": "Pepsi Cans 330Ml X24",
    "sku": "125",
    "cost": 7.59,
    "handle": "pepsi-can-330ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Pepsi Max 24 X 500Ml Gb",
    "sku": "215",
    "cost": 0.0,
    "handle": "pepsi-max-24-x-500ml-gb",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Pepsi Max Cans 330Ml X24",
    "sku": "124",
    "cost": 7.59,
    "handle": "pepsi-max-can-330ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Perrier Glassed Sparkling Water 330MI X24",
    "sku": "224",
    "cost": 10.99,
    "handle": "perrier-nrb-330mi-x24",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Perrier Nrb 750MI X12",
    "sku": "229",
    "cost": 12.99,
    "handle": "perrier-nrb-750mi-x12",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Perrier Water Can 35x250ml",
    "sku": "142",
    "cost": 11.29,
    "handle": "perrier-water-can-35-x-250ml",
    "category": "Food, Beverages & Tobacco > Beverages > Water > Carbonated Water",
    "status": "active"
  },
  {
    "title": "Picnic Std X36",
    "sku": "322",
    "cost": 17.5,
    "handle": "picnic-std-x36",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Polo Original 32 x 34g",
    "sku": "316",
    "cost": 0.0,
    "handle": "polo-original-32-x-34g",
    "category": "",
    "status": "draft"
  },
  {
    "title": "R White Lemonade Cans Gb 24 X 330MI",
    "sku": "109",
    "cost": 6.69,
    "handle": "rw-lemonade-cans-gb-24-x-330mi",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Red Bull Cans 250Ml X24",
    "sku": "123",
    "cost": 17.5,
    "handle": "red-bull-can-250ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Red Bull Sugar Free Energy Cans 250ml x 24",
    "sku": "122",
    "cost": 18.35,
    "handle": "red-bull-sugar-free-energy-cans-250ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Ribena Black 12x500MI",
    "sku": "223",
    "cost": 8.99,
    "handle": "ribena-black-500mi-x12",
    "category": "",
    "status": "active"
  },
  {
    "title": "Rio Tropical Cans 330Ml X24",
    "sku": "121",
    "cost": 7.99,
    "handle": "rio-can-330ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Rubicon Mango 24x330ML",
    "sku": "108",
    "cost": 0.0,
    "handle": "rubicon-mango-24x330ml",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Rubicon Mango Juice 12x1L",
    "sku": "267",
    "cost": 10.49,
    "handle": "rubicon-mango-juice-1l-x12",
    "category": "Food, Beverages & Tobacco > Beverages > Juices, Milkshakes & Smoothies",
    "status": "active"
  },
  {
    "title": "San Pellegrino Aranciata (Orange) 24 X 330MI Cans",
    "sku": "112",
    "cost": 10.99,
    "handle": "san-pellegrino-aranciata-orange-24-x-330mi-cans",
    "category": "",
    "status": "active"
  },
  {
    "title": "San Pellegrino Aranciata Rossa Red 24 X 330MI Cans",
    "sku": "111",
    "cost": 10.99,
    "handle": "san-pellegrino-aranciata-rossa-blood-orange-24-x-330mi-cans",
    "category": "Food, Beverages & Tobacco > Beverages",
    "status": "active"
  },
  {
    "title": "San Pellegrino Limonata (Lemon) 24 X 330MI Cans",
    "sku": "110",
    "cost": 10.99,
    "handle": "san-pellegrino-limonata-lemon-24-x-330mi-cans",
    "category": "",
    "status": "active"
  },
  {
    "title": "San Pellegrino Sparkling Water Glass Bottle 24 x 250ml",
    "sku": "102",
    "cost": 12.29,
    "handle": "san-pellegrino-sparkling-water-glass-bottle-24-x-250ml",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "San Pellegrino Sprk 1.Ltr X12",
    "sku": "228",
    "cost": 0.0,
    "handle": "san-pellegrino-sprk-1-ltr-x12",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Schweppes Ginger Beer 24 X 200Ml",
    "sku": "214",
    "cost": 12.79,
    "handle": "schweppes-ginger-beer-24-x-200ml-nrb",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Schweppes Lemonade Tonic Cans 24x150ml",
    "sku": "139",
    "cost": 7.99,
    "handle": "schweppes-slimline-tonic-cans-24-x-150ml",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "active"
  },
  {
    "title": "Schweppes Slimline Tonic 24 X 200Ml",
    "sku": "210",
    "cost": 12.79,
    "handle": "schweppes-slimline-tonic-24-x-200ml-nrb",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Schweppes Tonic 24 X 200Ml",
    "sku": "211",
    "cost": 12.79,
    "handle": "schweppes-tonic-24-x-200ml-nrb",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Snicker Std Bar 50G X40",
    "sku": "321",
    "cost": 14.5,
    "handle": "snicker-std-bar-50g-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Snickers Standard Bar 24x50g.",
    "sku": "338",
    "cost": 9.99,
    "handle": "snickers-standard-bar-24x50g",
    "category": "Food, Beverages & Tobacco > Food Items > Candy & Chocolate > Chocolate",
    "status": "active"
  },
  {
    "title": "Soda Water Cans 24x150ml",
    "sku": "140",
    "cost": 9.29,
    "handle": "soda-water-cans-24-x-150ml",
    "category": "Food, Beverages & Tobacco > Beverages > Water > Flat Mineral Water",
    "status": "active"
  },
  {
    "title": "Sparkling Water 500Ml X24",
    "sku": "243",
    "cost": 3.29,
    "handle": "sparkling-water-500ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Star Bar Std X32",
    "sku": "320",
    "cost": 11.99,
    "handle": "star-bar-std-x32",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "draft"
  },
  {
    "title": "Still Water Bottle 500Ml X24",
    "sku": "242",
    "cost": 2.99,
    "handle": "still-water-500ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Sunmagic Carrot Juice 12X500Ml",
    "sku": "240",
    "cost": 8.4,
    "handle": "sunmagic-carrot-500ml",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Sunmagic Orange Juice 12x500ml",
    "sku": "238",
    "cost": 11.99,
    "handle": "sunmagic-orange-12x500ml",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "draft"
  },
  {
    "title": "SunMagic Summer Sensation 12x500ML",
    "sku": "236",
    "cost": 0.0,
    "handle": "sunmagic-summer-sensation-12x500ml",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Sunmagic Tropical Juice 12X500Ml",
    "sku": "241",
    "cost": 8.1,
    "handle": "sunmagic-tropical-12x500ml",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Tango Apple Cans 330Ml X24",
    "sku": "120",
    "cost": 6.49,
    "handle": "tango-apple-can-330ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Tango Berry Can 330MI X24",
    "sku": "107",
    "cost": 6.49,
    "handle": "tango-berry-can-330mi-x24",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Tango Cherry Sugar Free Cans 24x330ml",
    "sku": "",
    "cost": 6.49,
    "handle": "tango-cherry-cans-24x330ml",
    "category": "Food, Beverages & Tobacco > Beverages > Soda",
    "status": "draft"
  },
  {
    "title": "Tango Orange 500MI X24",
    "sku": "218",
    "cost": 0.0,
    "handle": "tango-orange-500mi-x24",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Tango Orange Cans 330Ml X24",
    "sku": "119",
    "cost": 6.49,
    "handle": "tango-orange-cans-330ml-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Test Product",
    "sku": "",
    "cost": 0.0,
    "handle": "test-product",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Toblerone Chocolate 24X35g",
    "sku": "378",
    "cost": 9.75,
    "handle": "toblerone-chocolate-24x35-gm",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Toffee Crisp 38G Bar Std X48",
    "sku": "300",
    "cost": 0.0,
    "handle": "toffee-crisp-38g-bar-std-x48",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Tonic Water 200MI X24",
    "sku": "206",
    "cost": 12.79,
    "handle": "tonic-water-200mi-x24",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Topic Std X36",
    "sku": "304",
    "cost": 0.0,
    "handle": "topic-std-x36",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Twix 2 Finger Standard 30x30g",
    "sku": "319",
    "cost": 12.0,
    "handle": "twix-standard-30-x-2-x-50g",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Twix 25 x (2x25g)",
    "sku": "310",
    "cost": 8.49,
    "handle": "twix-25-x-2x25g",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Twix White Std 30x46g",
    "sku": "307",
    "cost": 11.0,
    "handle": "twix-white-std-50g-x32",
    "category": "Uncategorized",
    "status": "draft"
  },
  {
    "title": "Vita Coconut Water 330Ml X12",
    "sku": "232",
    "cost": 8.99,
    "handle": "coconut-water-330ml-x12",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Vitamin Water 500MI X12",
    "sku": "230",
    "cost": 0.0,
    "handle": "vitamin-water-500mi-x12",
    "category": "",
    "status": "draft"
  },
  {
    "title": "Volvic 10x1.5L",
    "sku": "268",
    "cost": 6.99,
    "handle": "volvic-1-5l-x10",
    "category": "Food, Beverages & Tobacco > Beverages > Water > Flat Mineral Water",
    "status": "active"
  },
  {
    "title": "Volvic 24x500ml",
    "sku": "219",
    "cost": 5.83,
    "handle": "volvic-500mi-x24",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Voss Still Water Glass 12 X 800ml",
    "sku": "270",
    "cost": 12.49,
    "handle": "voss-still-water-glass-12-x-800ml",
    "category": "Food, Beverages & Tobacco > Beverages > Water > Flat Mineral Water",
    "status": "active"
  },
  {
    "title": "Voss Still Water Glass 24 X 375ml",
    "sku": "269",
    "cost": 13.49,
    "handle": "voss-still-water-glass-24-x-375ml",
    "category": "Home & Garden > Kitchen & Dining > Tableware > Drinkware > Beer Glasses",
    "status": "active"
  },
  {
    "title": "Walkers Cheese & Onion Std 32G X32",
    "sku": "408",
    "cost": 13.99,
    "handle": "walkers-cheese-onion-std-32g-x32",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Walkers Prawn Cocktail Std 32G X32",
    "sku": "407",
    "cost": 13.99,
    "handle": "walkers-prawn-cocktail-std-32g-x32",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Walkers Ready Salted Std X32",
    "sku": "406",
    "cost": 13.99,
    "handle": "walkers-ready-salted-std-x32",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Walkers Roast Chicken Std 32G X32",
    "sku": "405",
    "cost": 13.99,
    "handle": "walkers-roast-chicken-std-32g-x32",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "draft"
  },
  {
    "title": "Walkers Salt & Vinegar Std 32G X32",
    "sku": "404",
    "cost": 13.99,
    "handle": "walkers-salt-vinegar-std-32g-x32",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Wispa Std X48",
    "sku": "318",
    "cost": 20.0,
    "handle": "wispa-std-x48",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  },
  {
    "title": "Yorkie Original 57G X24",
    "sku": "303",
    "cost": 11.99,
    "handle": "yorkie-original-57g-x24",
    "category": "Uncategorized",
    "status": "active"
  },
  {
    "title": "Yorkie Raisin Std 57G X24",
    "sku": "317",
    "cost": 11.99,
    "handle": "yorkie-raisin-std-57g-x24",
    "category": "Food, Beverages & Tobacco > Food Items",
    "status": "active"
  }
];
